export const API_ROUTES = {
    ////////////////////////////////////////////////////////////////////////////////////// AUTH
    AUTH_EMAIL_AVAILABLE: "/v1/one-verify/auth/email-available",
    AUTH_REGISTER: "/v1/one-verify/auth/register",
    AUTH_DEMO_LOGIN: "/v1/one-verify/auth/demo-login",
    AUTH_FORGOT_PASSWORD: "/v1/one-verify/auth/forgot-password",
    AUTH_FORGOT_PASSWORD_PROCESS: "/v1/one-verify/auth/forgot-password/process",
    AUTH_RESEND_VERIFY_RESEND: "/v1/one-verify/auth/verify-resend",
    AUTH_CONFIRM_USER: "/v1/one-verify/auth/confirm-user",
    AUTH_CHECK_INVITE_TOKEN: "/v1/one-verify/auth/invites/:inviteToken",
    AUTH_CHECK_AUTH_FLOW_IDENTITY_PROVIDER: "/v1/one-verify/auth/flow",

    ////////////////////////////////////////////////////////////////////////////////////// PROFILE
    PROFILE_GET: "/v1/one-verify/profile",
    PROFILE_ACCEPT_ORG_INVITATION:
        "/v1/one-verify/profile/invites/:inviteToken/accept",

    ////////////////////////////////////////////////////////////////////////////////////// PRACTICE
    PRACTICE_GET_USAGE_QUOTA:
        "/v1/one-verify/practices/:practiceId/usage-quota",
    PRACTICE_CONFIGURATIONS_GET:
        "/v1/one-verify/practices/:practiceId/configurations",
    PRACTICE_CONFIGURATIONS_UPSERT:
        "/v1/one-verify/practices/:practiceId/configurations",

    ////////////////////////////////////////////////////////////////////////////////////// ORGANIZATION USERS
    ORGANIZATION_USERS_GET_LIST: "/v1/one-verify/practices/:practiceId/users",
    ORGANIZATION_USERS_DELETE:
        "/v1/one-verify/practices/:practiceId/users/:userId",
    ORGANIZATION_USERS_CHANGE_ROLE:
        "/v1/one-verify/practices/:practiceId/users/:userId/role",
    ORGANIZATION_USERS_RESET_MFA:
        "/v1/one-verify/practices/:practiceId/users/:userId/mfa",
    ORGANIZATION_USERS_INVITE: "/v1/one-verify/practices/:practiceId/invites",
    ORGANIZATION_USERS_GET_INVITES_LIST:
        "/v1/one-verify/practices/:practiceId/invites",
    ORGANIZATION_USERS_DELETE_INVITE:
        "/v1/one-verify/practices/:practiceId/invites/:inviteId",
    ORGANIZATION_USERS_CHANGE_INVITE_ROLE:
        "/v1/one-verify/practices/:practiceId/invites/:inviteId/role",

    ////////////////////////////////////////////////////////////////////////////////////// PAYERS
    PAYERS_GET_LIST: "/v1/one-verify/practices/:practiceId/payers",
    PAYERS_CREATE_INSTANCE: "/v1/one-verify/practices/:practiceId/payers",
    PAYERS_UPDATE_INSTANCE:
        "/v1/one-verify/practices/:practiceId/payers/:payerId",
    PAYERS_DELETE_INSTANCE:
        "/v1/one-verify/practices/:practiceId/payers/:payerId",

    ////////////////////////////////////////////////////////////////////////////////////// PAYER MAPPINGS
    PAYER_MAPPINGS_GET_LIST:
        "/v1/one-verify/practices/:practiceId/payer-mappings",
    PAYER_MAPPINGS_CREATE_INSTANCE:
        "/v1/one-verify/practices/:practiceId/payer-mappings",
    PAYER_MAPPINGS_UPDATE_INSTANCE:
        "/v1/one-verify/practices/:practiceId/payer-mappings/:mappingId",
    PAYER_MAPPINGS_DELETE_INSTANCE:
        "/v1/one-verify/practices/:practiceId/payer-mappings/:mappingId",

    PAYER_MAPPINGS_VALIDATE_BULK:
        "/v1/one-verify/practices/:practiceId/payer-mappings/bulk/validate",
    PAYER_MAPPINGS_UPSERT_BULK:
        "/v1/one-verify/practices/:practiceId/payer-mappings/bulk",

    PAYER_MAPPINGS_RESOLVE:
        "/v1/one-verify/practices/:practiceId/payer-mappings/resolve",

    ////////////////////////////////////////////////////////////////////////////////////// COVERAGE
    COVERAGE_GET_DISCOVER_COVERAGE:
        "/v1/one-verify/practices/:practiceId/coverage/discover",
    COVERAGE_GET_SMART_SCAN_COVERAGE:
        "/v1/one-verify/practices/:practiceId/coverage/smart-scan",
    COVERAGE_GET_COVERAGE_GENERAL:
        "/v1/one-verify/practices/:practiceId/coverage/general",
    COVERAGE_GET_MEDICAID_COVERAGE:
        "/v1/one-verify/practices/:practiceId/coverage/medicaid",
    COVERAGE_GET_AGENTIC_PHONE_COVERAGE:
        "/v1/one-verify/practices/:practiceId/coverage/agentic-phone",

    ////////////////////////////////////////////////////////////////////////////////////// BILLER GROUPS
    BILLER_GROUPS_GET_LIST:
        "/v1/one-verify/practices/:practiceId/biller-groups",
    BILLER_GROUPS_CREATE: "/v1/one-verify/practices/:practiceId/biller-groups",
    BILLER_GROUPS_GET_SINGLE:
        "/v1/one-verify/practices/:practiceId/biller-groups/:billerGroupId",
    BILLER_GROUPS_UPDATE_SINGLE:
        "/v1/one-verify/practices/:practiceId/biller-groups/:billerGroupId",
    BILLER_GROUPS_DELETE_SINGLE:
        "/v1/one-verify/practices/:practiceId/biller-groups/:billerGroupId",
    BILLER_GROUPS_UPDATE_USERS:
        "/v1/one-verify/practices/:practiceId/biller-groups/:billerGroupId/users",

    ////////////////////////////////////////////////////////////////////////////////////// COVERAGE CHECKS HISTORY
    COVERAGE_HISTORY_GET_LIST: "/v2/one-verify/practices/:practiceId/history",
    COVERAGE_HISTORY_GET_SINGLE:
        "/v2/one-verify/practices/:practiceId/history/:nirvanaRequestId",
    COVERAGE_HISTORY_GET_SINGLE_RELATED_HISTORY:
        "/v2/one-verify/practices/:practiceId/history/:nirvanaRequestId/history",
    COVERAGE_HISTORY_RETRY_SINGLE:
        "/v2/one-verify/practices/:practiceId/history/:nirvanaRequestId/retry",
    COVERAGE_REPORTS_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/reports",
    COVERAGE_REPORTS_GET_AGGREGATION_STATUS_CODES:
        "/v2/one-verify/practices/:practiceId/history/reports/aggregations/status-codes",
    COVERAGE_REPORTS_GET_AGGREGATION_FLAGS:
        "/v2/one-verify/practices/:practiceId/history/reports/aggregations/flags",
    COVERAGE_PLAN_YEAR_RESETS_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/plan-year-resets",
    COVERAGE_PLAN_YEAR_RESETS_GET_AGGREGATIONS:
        "/v2/one-verify/practices/:practiceId/history/reports/aggregations/plan-year-resets",
    COVERAGE_OVERRIDES_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/overrides",
    COVERAGE_MEDICAID_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/medicaid",
    COVERAGE_MEDICAID_GET_AGGREGATION_PLAN_TYPE:
        "/v2/one-verify/practices/:practiceId/history/medicaid/aggregations/plan-type",
    COVERAGE_MEDICAID_GET_AGGREGATION_ACTIVE_PLAN_TYPE:
        "/v2/one-verify/practices/:practiceId/history/medicaid/aggregations/active-plan-type",
    COVERAGE_AGENTIC_REPORTS_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/agentic",
    COVERAGE_TASK_ASSIGNMENT_GET_LIST:
        "/v2/one-verify/practices/:practiceId/history/tasks",
    COVERAGE_WRITE_TO_EHR:
        "/v1/one-verify/practices/:practiceId/ehr-writes/:nirvanaRequestId",

    ////////////////////////////////////////////////////////////////////////////////////// HISTORY EXPORT
    COVERAGE_HISTORY_EXPORT_CREATE:
        "/v2/one-verify/practices/:practiceId/history/export",
    COVERAGE_HISTORY_EXPORT_GET:
        "/v2/one-verify/practices/:practiceId/history/export/:exportFileName",

    ////////////////////////////////////////////////////////////////////////////////////// TASK ASSIGNMENTS
    TASK_ASSIGNMENTS_GET_LIST:
        "/v1/one-verify/practices/:practiceId/assignments",
    TASK_ASSIGNMENTS_CREATE: "/v1/one-verify/practices/:practiceId/assignments",
    TASK_ASSIGNMENTS_REASSIGN:
        "/v1/one-verify/practices/:practiceId/assignments/:assignmentId/reassign",
    TASK_ASSIGNMENTS_UPDATE_STATUS:
        "/v1/one-verify/practices/:practiceId/assignments/:assignmentId/status",
    TASK_ASSIGNMENTS_UPDATE_PRIORITY:
        "/v1/one-verify/practices/:practiceId/assignments/:assignmentId/priority",
    TASK_ASSIGNMENTS_PRODUCTIVITY_EXPORT:
        "/v1/one-verify/practices/:practiceId/assignments/productivity-export",
    TASK_ASSIGNMENTS_PRODUCTIVITY_EXPORT_COUNT:
        "/v1/one-verify/practices/:practiceId/assignments/productivity-export/count",

    ////////////////////////////////////////////////////////////////////////////////////// REPORT SAVED FILTERS
    SAVED_FILTERS_GET_LIST:
        "/v1/one-verify/practices/:practiceId/saved-filters",
    SAVED_FILTERS_CREATE: "/v1/one-verify/practices/:practiceId/saved-filters",
    SAVED_FILTERS_DELETE:
        "/v1/one-verify/practices/:practiceId/saved-filters/:filterId",

    ////////////////////////////////////////////////////////////////////////////////////// COVERAGE CHECKS COMMENTS
    COMMENTS_GET_LIST: "/v1/one-verify/practices/:practiceId/comments",
    COMMENTS_CREATE: "/v1/one-verify/practices/:practiceId/comments",
    COMMENTS_UPDATE_SINGLE:
        "/v1/one-verify/practices/:practiceId/comments/:commentId",
    COMMENTS_DELETE_SINGLE:
        "/v1/one-verify/practices/:practiceId/comments/:commentId",

    ////////////////////////////////////////////////////////////////////////////////////// COVERAGE OVERRIDES
    COVERAGE_OVERRIDES_CREATE: "/v1/one-verify/practices/:practiceId/overrides",
    COVERAGE_OVERRIDES_GET_SINGLE:
        "/v1/one-verify/practices/:practiceId/overrides",
    COVERAGE_OVERRIDES_DELETE:
        "/v1/one-verify/practices/:practiceId/overrides/:overrideNirvanaRequestId",

    ////////////////////////////////////////////////////////////////////////////////////// NETWORK STATUS
    NETWORK_STATUS_RULES_GET_LIST:
        "/v1/one-verify/practices/:practiceId/network-status/rules",
    /** POST to create rules (same path as GET list). */
    NETWORK_STATUS_RULES_CREATE:
        "/v1/one-verify/practices/:practiceId/network-status/rules",
    NETWORK_STATUS_RULES_VALIDATE:
        "/v1/one-verify/practices/:practiceId/network-status/rules/validate",
    NETWORK_STATUS_VERSIONS_GET:
        "/v1/one-verify/practices/:practiceId/network-status/versions",
    NETWORK_STATUS_ACTIVE_VERSION_PUT:
        "/v1/one-verify/practices/:practiceId/network-status/active-version",

    ////////////////////////////////////////////////////////////////////////////////////// FEATURE FLAGS
    FEATURE_FLAGS_GET_ENABLED_LIST:
        "/v1/one-verify/practices/:practiceId/feature-flags/enabled",

    ////////////////////////////////////////////////////////////////////////////////////// SUPPORT
    SUPPORT_REPORT_COVERAGE_RESULT:
        "/v1/one-verify/practices/:practiceId/support/report-result",

    ////////////////////////////////////////////////////////////////////////////////////// INTEGRATIONS
    INTEGRATIONS_SUPPORT:
        "/v1/one-verify/practices/:practiceId/integrations/support",
    INTEGRATIONS_ERA_UPLOADS:
        "/v1/one-verify/practices/:practiceId/integrations/era-uploads",
    INTEGRATIONS_ERA_UPLOAD:
        "/v1/one-verify/practices/:practiceId/integrations/era-uploads/:uploadId",

    ////////////////////////////////////////////////////////////////////////////////////// DASHBOARD
    DASHBOARD_GET_EMBED_TOKEN:
        "/v1/one-verify/practices/:practiceId/dashboard/embed-token",
}

const authUrl = "/auth"

export const ROUTES_CONFIG = {
    baseApplicationUrl: "/",

    authUrl,
    loginUrl: `${authUrl}/login`,
    demoLoginUrl: `${authUrl}/demo`,
    logoutUrl: `${authUrl}/logout`,
    confirmUserUrl: `${authUrl}/confirm-user`,
    authCallbackUrl: `${authUrl}/callback`,

    registerUrl: `${authUrl}/register`,
    registerSuccessUrl: `${authUrl}/register/success`,

    restoreUrl: `${authUrl}/restore`,
    restoreProcessUrl: `${authUrl}/restore/process`,

    coverageCheckerUrl: "/coverage-checker",
    organizationUrl: "/organization",
    configurationsUrl: "/configurations",

    searchUrl: "/search",
    searchSinglePolicyUrl: "/search/:nirvanaRequestId",

    reportsUrl: "/reports",
    reportsSinglePolicyUrl: "/reports/:nirvanaRequestId",

    medicaidReportsUrl: "/medicaid",
    medicaidReportsSinglePolicyUrl: "/medicaid/:nirvanaRequestId",

    overridesUrl: "/overrides",
    overridesSinglePolicyUrl: "/overrides/:nirvanaRequestId",

    agenticReportsUrl: "/agentic",
    agenticReportsSinglePolicyUrl: "/agentic/:nirvanaRequestId",

    planYearResetsUrl: "/plan-year-resets",
    planYearResetsSinglePolicyUrl: "/plan-year-resets/:nirvanaRequestId",

    profileUrl: "/profile",

    downloadExportUrl: "/download/exports/:exportFileName",

    supportedPayersStandardUrl: "/supported-payers/standard",
    supportedPayersDiscoverUrl: "/supported-payers/discover",
    supportedPayersAgenticUrl: "/supported-payers/agentic",

    workflowManagementUrl: "/workflows",
    taskAssignmentsUrl: "/workflows/manage-assignments",
    taskAssignmentsSinglePolicyUrl:
        "/workflows/manage-assignments/:nirvanaRequestId",
    assignedTasksUrl: "/workflows/assignments",
    assignedTasksSinglePolicyUrl: "/workflows/assignments/:nirvanaRequestId",
    manageGroupsUrl: "/workflows/groups",

    networkStatusRulesUrl: "/network-status",

    insightsUrl: "/insights",

    integrationsUrl: "/integrations",
}

// Make coverage checker a default url in application
ROUTES_CONFIG.baseApplicationUrl = ROUTES_CONFIG.coverageCheckerUrl

export const ROUTES_MENU_FREE_CONFIG = [] as string[]

// Route that shouldn't have left and right margins on the screen
export const ROUTES_FULL_SCREEN_WIDTH = [
    ROUTES_CONFIG.organizationUrl,
    ROUTES_CONFIG.searchUrl,
    ROUTES_CONFIG.searchSinglePolicyUrl,
    ROUTES_CONFIG.reportsUrl,
    ROUTES_CONFIG.reportsSinglePolicyUrl,
    ROUTES_CONFIG.overridesUrl,
    ROUTES_CONFIG.overridesSinglePolicyUrl,
    ROUTES_CONFIG.planYearResetsUrl,
    ROUTES_CONFIG.planYearResetsSinglePolicyUrl,
    ROUTES_CONFIG.medicaidReportsUrl,
    ROUTES_CONFIG.medicaidReportsSinglePolicyUrl,
    ROUTES_CONFIG.agenticReportsUrl,
    ROUTES_CONFIG.agenticReportsSinglePolicyUrl,
    ROUTES_CONFIG.workflowManagementUrl,
    ROUTES_CONFIG.taskAssignmentsUrl,
    ROUTES_CONFIG.taskAssignmentsSinglePolicyUrl,
    ROUTES_CONFIG.assignedTasksUrl,
    ROUTES_CONFIG.assignedTasksSinglePolicyUrl,
    ROUTES_CONFIG.manageGroupsUrl,
    ROUTES_CONFIG.networkStatusRulesUrl,
    ROUTES_CONFIG.insightsUrl,
]
